export enum uploadFiles {
  croppedlogo = 'croppedlogo',
  gallery = 'gallery',
  presentation = 'presentation'
}
